module.exports = __webpack_public_path__ + "img/no-data.e2e75e0.svg";